<template>
    <div>
        <!-- Icones Linkedin, Facebook, Intagram e Youtube -->
        <v-footer padless>
            <v-card width="100%" color="#278B97" class="pa-3 text-center">
                <a href="https://www.linkedin.com/company/hepta-tecnologia/mycompany/"
                    target="_blank" rel="noopener noreferrer"
                    aria-label="Hepta no LinkedIn (abre em nova aba)">
                    <v-icon class="pa-5" size="18" color="white">fa-brands fa-linkedin-in</v-icon>
                </a>
                <a href="https://www.facebook.com/heptatecnologia"
                    target="_blank" rel="noopener noreferrer"
                    aria-label="Hepta no Facebook (abre em nova aba)">
                    <v-icon class="pa-5" size="18" color="white">fa-brands fa-facebook</v-icon>
                </a>
                <a href="https://www.instagram.com/heptatecnologia/"
                    target="_blank" rel="noopener noreferrer"
                    aria-label="Hepta no Instagram (abre em nova aba)">
                    <v-icon class="pa-5" size="18" color="white">fa-brands fa-instagram</v-icon>
                </a>
                <a href="https://www.youtube.com/heptatecnologia"
                    target="_blank" rel="noopener noreferrer"
                    aria-label="Hepta no YouTube (abre em nova aba)">
                    <v-icon class="pa-5" size="18" color="white">fa-brands fa-youtube</v-icon>
                </a>
            </v-card>

        </v-footer>
    </div>
</template>
<script>
export default {
    data: () => ({
    }),
}
</script>
<style scoped></style>
